import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/es/colors/red';

import { dark, light } from '@material-ui/core/es/styles/createPalette';
import { getContrastRatio } from '@material-ui/core/es/styles/colorManipulator';

const getContrastText = (background) =>
  getContrastRatio(background, dark.text.primary) >= 3 ? dark.text.primary : light.text.primary;

// Create a theme instance.
const theme = createMuiTheme({
  palette: {
    primary: {
      light: red[500],
      main: red[700],
      dark: red[900],
      contrastText: getContrastText(red[700]),
    }
  },
  overrides: {
    MuiDrawer: {
      root: {
        zIndex: '1204 !important',
        width: 'max-content',
      },
      paper: {
        marginTop: 65,
        height: 'calc(100% - 65px)',
        zIndex: 1204,
      },
    },
    MuiIconButton: {
      root: {
        color: '#000',
      }
    },
  },
});

export default theme;
